import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN;
const isProd = import.meta.env.PROD;

export function initSentry() {
  if (!DSN) {
    if (isProd) {
      // eslint-disable-next-line no-console
      console.warn('[sentry] VITE_SENTRY_DSN no configurado en build de producción');
    }
    return;
  }

  Sentry.init({
    dsn: DSN,
    environment: isProd ? 'production' : 'development',
    release: import.meta.env.VITE_SENTRY_RELEASE,

    sendDefaultPii: false,
    attachStacktrace: true,

    tracesSampleRate: 0,

    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.data?.url && typeof breadcrumb.data.url === 'string') {
        breadcrumb.data.url = scrubUrl(breadcrumb.data.url);
      }
      return breadcrumb;
    },

    beforeSend(event) {
      if (event.request?.url) event.request.url = scrubUrl(event.request.url);
      if (event.transaction) event.transaction = scrubUrl(event.transaction);
      return event;
    },
  });
}

function scrubUrl(url: string): string {
  return url
    .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, ':uuid')
    .replace(/\/\d{6,}/g, '/:id');
}

export { Sentry };
